module.exports = __webpack_public_path__ + "img/a1.65b83bd6.jpg";